import './PasswordPolicySwitch.css';
import { useIntl } from 'react-intl';
import { ResetPassword } from '@tfo/common';
import $http from '../../../utils/$http';
import { makeStyles } from '@material-ui/core';



export const PasswordPolicySwitch = () => {
    const intl = useIntl();
    const useStyles = makeStyles({
        input: {
            fontFamily: 'Arial',
            fontSize: '1.6rem',
            letterSpacing: '0.001rem',
            lineHeight: '2.8rem',
            color: '#3D3D3C',
            background: '#ffffff',
            border: '1px solid #dfdfde',
            position: 'relative',
            padding: '0.4rem 0.4rem',
            width: '350px',
            margin: 0,
            opacity: 1,
            zIndex: 0,
            '& .MuiInput-underline:before, & .MuiInput-underline:after, & .MuiInput-underline:hover:not(.Mui-disabled):before': {
                borderBottom: 'none',
            },
            '.MuiTextField-root:focus': {
                borderColor: '#0098c3',
                zIndex: 2,
            },
        },
        inputPassword: {
            width: '350px',
            padding: '0.6rem 0.6rem',
            borderRadius: '0',
            backgroundColor: '#FFFFFF'

        },
        button: {
            width: '350px',
            height: '64px',
            backgroundColor: '#009B48',
            fontWeight: 'bold',
            color: '#ffffff',
            fontStyle: 'normal',
            fontFamily: 'Arial, sans-serif',
            textTransform: 'none',
            fontSize: '1.6rem',
            borderRadius: 0,
            '&:hover': {
                backgroundColor: '#48C865',
            },
        },
        label: {
            marginBottom: '10px'
        },
        passwordValidations: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            margin: 'auto',
            marginLeft: '30px',
            width: '60%',
            height: '24px',

        },
        passwordValidationsGrid: {
            margin: 'auto',
            width: '300px',
            borderRadius: '12px',
            marginBottom: '12px'

        },
        passwordRepeatErrorText: {
            color: '#F50057',
            fontWeight: 'bold',
            letterSpacing: '0.4px',
        },
    })

    const changePassword = async (data: any) => {
        return await $http.post<any>(`/user/password/set-new`, data)
    }


    return (
        <>
            <h1 className='passwordPolicy__h1'>{intl.formatMessage({ id: 'password.policy.switch.header' })}</h1>
            <h2 className='passwordPolicy__h2'>{intl.formatMessage({ id: 'password.policy.switch.subheader' })}</h2>
            <div className='passwordPolicy__inputDiv'>
                <ResetPassword
                    apiMethod={changePassword}
                    useStyles={useStyles}
                    showOldPassword={false}
                    hasLabels={true} />
            </div>

        </>

    )

}